import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-requisites",
  "use": "medexpert-requisites-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-requisites\">\r\n<path opacity=\"0.2\" d=\"M8 13C5.239 13 3 10.761 3 8C3 5.239 5.239 3 8 3C10.761 3 13 5.239 13 8C13 10.761 10.761 13 8 13ZM8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16Z\" />\r\n<path d=\"M11 8C11 9.657 9.657 11 8 11C6.343 11 5 9.657 5 8C5 6.343 6.343 5 8 5C9.657 5 11 6.343 11 8Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol